import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { useNavigate, useSearchParams } from "react-router-dom";
import { StatusBadge } from "@/components/StatusBadge";
import { STAGE_PRODUCTION } from "@/lib/constants";
import { fmtDate } from "@/lib/format";
import { Loader2, Wrench, ArrowRight } from "lucide-react";

export default function RepairOrders() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const status = params.get("status") || "";
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/repair-orders", { params: status ? { status } : {} }).then(({ data }) => setList(data)).finally(() => setLoading(false));
  }, [status]);

  const tabs = [["", "Semua Unit"], ...STAGE_PRODUCTION.map((s) => [s, s]), ["Unit Out", "Unit Out"]];

  return (
    <div className="space-y-4" data-testid="repair-orders-page">
      <div><h1 className="font-heading text-2xl font-bold text-navy">Repair Order</h1><p className="text-sm text-muted-foreground">{list.length} unit</p></div>
      <div className="flex gap-2 flex-wrap">
        {tabs.map(([v, l]) => (
          <button key={v} data-testid={`ro-tab-${v || "all"}`} onClick={() => { const np = new URLSearchParams(); if (v) np.set("status", v); setParams(np); }}
            className={`px-3 py-1.5 rounded-full text-xs font-medium border ${status === v ? "bg-navy text-white border-navy" : "bg-white text-slate-600"}`}>{l}</button>
        ))}
      </div>

      {loading ? <div className="flex justify-center py-16"><Loader2 className="h-7 w-7 animate-spin text-primary" /></div> : (
        list.length === 0 ? <Card className="p-10 text-center text-muted-foreground"><Wrench className="mx-auto mb-2 opacity-40" /> Tidak ada Repair Order.</Card> : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {list.map((p) => (
              <Card key={p.id} data-testid={`ro-card-${p.ro_number}`} className="p-4 space-y-2 cursor-pointer hover:shadow-md" onClick={() => navigate(`/repair-orders/${p.id}`)}>
                <div className="flex items-center justify-between">
                  <span className="font-mono-k3 text-xs font-semibold text-emerald-700">{p.ro_number}</span>
                  <StatusBadge status={p.stage} />
                </div>
                <div className="font-semibold">{p.plate} · {p.customer_name}</div>
                <div className="text-xs text-muted-foreground">{p.brand} {p.model} · {p.work_type}</div>
                <div className="text-xs">Target: {fmtDate(p.target_date)} · {p.days_running != null ? `${p.days_running} hari berjalan` : "-"}</div>
                <div className="text-xs">PJ: {p.penanggung_jawab_name || <span className="text-primary">Belum ada PJ</span>}</div>
                <div className="flex items-center justify-between pt-1">
                  <span className="font-mono-k3 text-[10px] text-primary">{p.project_id}</span>
                  <ArrowRight size={14} className="text-muted-foreground" />
                </div>
              </Card>
            ))}
          </div>
        )
      )}
    </div>
  );
}
